module.exports = __webpack_public_path__ + "img/box-ballot.36b1c7ba.svg";